import $ from "jquery";

export const getCurrentUsdBalanceAmount = () => {
    return $('#user-balance-usd').text();
}

export const getCurrentLoanLimit = () => {
    return $('#current-loan-limit').text();
}

export const getAvailableLoanAmount = () => {
    return $('#available-loan-limit').text();
}

export const getRequestLoanAmount = () => {
    return $('#amount-loan').val();
}
